import { useLocation, useNavigate } from 'react-router-dom';
import './style.css';
import { useEffect, useState } from 'react';
import Progress from '../../components/progress';
import { http_request } from '../../libs/connection';
import { DEFAULT_ROWS, SESSION_EXPIRED_CODE } from '../../config';
import { getUserInfo, logout } from '../../libs/lib';
import { Button, FormControl, ButtonGroup, Modal, Toast, ToastContainer, FormSelect, FormGroup, Form } from 'react-bootstrap';

var page = 1;

export default function CompanyUser(props){
    const navigate = useNavigate();
    const location = useLocation();
    const { pathname } = location;
    const user_info = getUserInfo();
    const [is_loading, setLoadingStatus] = useState(false);
    const [users, setUsers] = useState([]);
    const [total, setTotal] = useState(0);
    const [permissions, setPermissions] = useState([]);
    const [search, setSearch] = useState('');
    const [user_editor_show, showUserEditor] = useState(false);
    const [password_editor_show, showPasswordEditor] = useState(false);
    const [editing_user, setEditingUser] = useState({});
    const [password, setPassword] = useState('');
    const [success_toast_show, showSuccessToast] = useState(false);
    const [error_toast_show, showErrorToast] = useState(false);
    const [success_message, setSuccessMessage] = useState('');
    const [error_message, setErrorMessage] = useState('');

    
    useEffect(()=>{
        page = 1;
        loadPermissions();
        loadUsers();
    }, [pathname]);

    function loadPermissions(){
        return new Promise(resolve=>{
            http_request('/company/user/permissions', 'GET').then(res=>{
                resolve();
                if(res.success){
                    let list = res.data.permissions || [];
                    if(!Array.isArray(list)) list = Object.values(list);
                    setPermissions(list);
                }else if(res.message === SESSION_EXPIRED_CODE){
                    logout();
                }
            });
        })
    }
    function loadUsers(){
        if(is_loading) return;
        setLoadingStatus(true);
        let params = {
            company_id: user_info.company_id,
            page,
            rows: DEFAULT_ROWS
        };
        if(search) params.search = search;
        http_request('/company/user/list', 'POST', params).then(res=>{
            setLoadingStatus(false);
            if(res.success){
                let data = res.data.company_users || [];
                if(page === 1){
                    setUsers(data);
                }else{
                    setUsers([...users, ...data]);
                }
                setTotal(res.data.total);;
            }else if(res.message === SESSION_EXPIRED_CODE){
                logout();
            }
        });
    }
    function query(){
        page = 1;
        loadUsers();
    }
    function loadMore(e){
        if(page * DEFAULT_ROWS <= total){
          page += 1;
          loadUsers();
        }
    }

    
    function popPasswordEditor(user){
        setEditingUser(Object.assign({}, user));
        setPassword('');
        showPasswordEditor(true);
    }

    function popUserEditor(user){
        setEditingUser(Object.assign({}, user));
        showUserEditor(true);
    }

    function editNewUser(){
        setEditingUser({ name: '新用户', permissions: [], status: 1 });
        showUserEditor(true);
    }

    function editUser(){
        let params = {
            name: editing_user.name,
            permissions: editing_user.permissions.map(e=>e.id),
            status: editing_user.status
        };
        if(editing_user.id){
            params.id = editing_user.id;
        }else{
            params.account = editing_user.account;
        }
        if(password.length) params.password = password;
        let action = editing_user.id ? 'edit' : 'create';
        http_request(`/company/user/${action}`, 'POST', params).then(res=>{
            if(res.success){
                setSuccessMessage(`已更新帐号: ${editing_user.account}`);
                showSuccessToast(true);
                showUserEditor(false);
                loadUsers();
            }else if(res.message === SESSION_EXPIRED_CODE){
                logout();
            }else{
                setErrorMessage(res.message);
                showErrorToast(true);
            }
        });
    }
    
    function resetPassword(){
        let params = {
            id: editing_user.id,
            name: editing_user.name,
            permissions: editing_user.permissions.map(e=>e.id),
            password
        };
        http_request('/company/user/edit', 'POST', params).then(res=>{
            if(res.success){
                setSuccessMessage(`已重设帐号: ${editing_user.account} 的密码`);
                showSuccessToast(true);
                showPasswordEditor(false);
            }else if(res.message === SESSION_EXPIRED_CODE){
                logout();
            }else{
                setErrorMessage(res.message);
                showErrorToast(true);
            }
        });
    }

    function isValidForm(){
        let q1 = editing_user.name;
        let q2 = editing_user.account;
        let q3 = editing_user.id || password;
        return q1 && q2 && q3;
    }

    return <div id="page-company-user" className=' d-flex flex-column flex-grow-1 bg-light'>
        <Progress show={is_loading} />
        <Modal
            centered
            show={password_editor_show}
            onHide={()=>{ showPasswordEditor(false); }}
        >
            <Modal.Header closeButton>
                <span>重设密码</span>
                <span className='ms-1'>{editing_user.account}</span>
                <span className='ms-1'>{editing_user.name}</span>
            </Modal.Header>
            <Modal.Body>
                <FormControl
                    type='password'
                    value={password}
                    onChange={e=>{ setPassword(e.currentTarget.value); }}
                    placeholder='输入密码'
                />
            </Modal.Body>
            <Modal.Footer className='d-flex align-items-center justify-content-between'>
                <Button 
                    size="sm" 
                    variant='danger'
                    onClick={()=>{ showPasswordEditor(false); }}
                >取消</Button>
                <Button 
                    size="sm" 
                    variant='success' 
                    disabled={password.length === 0} 
                    onClick={()=>{ resetPassword(); }}
                >重设密码</Button>
            </Modal.Footer>
        </Modal>
        <Modal
            centered
            show={user_editor_show}
            onHide={()=>{ showUserEditor(false); }}
        >
            <Modal.Header closeButton>
                <span>编辑帐号</span>
                <span className='ms-1'>{editing_user.account}</span>
            </Modal.Header>
            <Modal.Body>
                <FormGroup className='ms-1 mb-2 border-bottom'>
                    <Form.Check
                        type="switch"
                        id="user-status"
                        label="启用帐号"
                        value={1}
                        checked={editing_user.status == 1}
                        onChange={()=>{
                            let new_object = Object.assign({}, editing_user);
                            new_object.status = new_object.status ? 0 : 1;
                            setEditingUser(new_object);
                        }}
                    />
                </FormGroup>
                {
                    editing_user.id ? '' : <FormGroup className='mb-3'>
                        <Form.Label column sm="2">
                            帐号
                        </Form.Label>
                        <FormControl
                            type='text'
                            value={editing_user.account}
                            onChange={e=>{
                                let new_object = Object.assign({}, editing_user);
                                new_object.account = e.currentTarget.value;
                                setEditingUser(new_object);
                            }}
                            placeholder='帐号'
                        />
                    </FormGroup>
                }
                <FormGroup className='mb-2'>
                    <Form.Label column sm="2">
                        名称
                    </Form.Label>
                    <FormControl
                        type='text'
                        value={editing_user.name}
                        onChange={e=>{
                            let new_object = Object.assign({}, editing_user);
                            new_object.name = e.currentTarget.value;
                            setEditingUser(new_object);
                        }}
                        placeholder='名称'
                    />
                </FormGroup>
                {
                    editing_user.id ? '' : <FormGroup className='mb-3'>
                        <Form.Label column sm="2">
                            密码
                        </Form.Label>
                        <FormControl
                            type='password'
                            value={password}
                            onChange={e=>{ setPassword(e.currentTarget.value); }}
                            placeholder='密码'
                        />
                    </FormGroup>
                }
                <FormGroup>
                    {
                        permissions.map((permission, p)=><Form.Check 
                            key={p}
                            type={'checkbox'}
                            id={`check-${permission.id}`}
                            label={permission.name}
                            value={permission.id}
                            checked={(editing_user.permissions || []).map(p=>p.id).includes(permission.id)}
                            onChange={e=>{
                                let new_object = Object.assign({}, editing_user);
                                let find = new_object.permissions.findIndex(e=>e.id == permission.id)
                                if(find === -1){
                                    new_object.permissions.push(permission);
                                }else{
                                    new_object.permissions.splice(find, 1);
                                }
                                setEditingUser(new_object);
                            }}
                        />)
                    }
                </FormGroup>
            </Modal.Body>
            <Modal.Footer className='d-flex align-items-center justify-content-between'>
                <Button 
                    size="sm" 
                    variant='danger'
                    onClick={()=>{ showUserEditor(false); }}
                >取消</Button>
                <Button 
                    size="sm" 
                    variant='success' 
                    onClick={()=>{ editUser(); }}
                    disabled={!isValidForm()}
                >更新</Button>
            </Modal.Footer>
        </Modal>
        <ToastContainer 
            position='middle-bottom'
            style={{ zIndex: 1056 }}
            >
            <Toast 
                show={success_toast_show} 
                onClose={()=>{ showSuccessToast(false); }}
                delay={2000}
                autohide
                bg="success"
                className='text-white'
            >
                <Toast.Header>
                    <strong className="me-auto">更新完成</strong>
                </Toast.Header>
                <Toast.Body>{success_message}</Toast.Body>
            </Toast>
        </ToastContainer>
        <ToastContainer
            position='middle-bottom'
            style={{ zIndex: 1056 }}
        >
            <Toast 
                show={error_toast_show} 
                onClose={()=>{ showErrorToast(false); }}
                delay={3000}
                autohide
                bg="danger"
                className='text-white'
            >
                <Toast.Header>
                    <strong className="me-auto">更新失败</strong>
                </Toast.Header>
                <Toast.Body>{error_message}</Toast.Body>
            </Toast>
        </ToastContainer>
        <div className='container d-flex align-items-center px-3 pt-sm-0 pt-3'>
            <span className='fs-6 flex-grow-1 d-flex align-items-center'>
                <span>设置厂商使用者</span>
                <div className='d-sm-none d-block'>
                    <Button variant='warning' className='ms-2' size="sm" onClick={()=>{ editNewUser(); }}>新增使用者</Button>
                </div>
            </span>
            <span className='d-sm-flex d-none pe-2'>
                <Button variant='warning' size="sm" onClick={()=>{ editNewUser(); }} >新增使用者</Button>
            </span>
            <span className='d-sm-flex d-none'>
                <Search search={search} setSearch={setSearch} query={query} />
            </span>
        </div>
        <div className='d-sm-none d-block'>
            <Search search={search} setSearch={setSearch} query={query} />
        </div>
        <div className={`container p-2 overflow-auto flex-grow-1`}>
            <ul className='m-0 p-0'>
            {
                users.map((row, r)=><li key={r} className={`block mb-2 p-3`}>
                <div className='account'>{row.account}</div>
                <div className='name'>{row.name}</div>
                <div className='d-flex align-items-start justify-content-start'>
                    <div className='pt-3 pe-5'>
                        <Button 
                            size="sm" 
                            variant='success' 
                            className='px-4 me-2' 
                            onClick={()=>{
                                popPasswordEditor(row);
                            }}
                        >重设密码</Button>
                        <Button 
                            size="sm" 
                            variant='primary' 
                            className='px-4' 
                            onClick={()=>{
                                popUserEditor(row);
                            }}
                        >编辑帐号</Button>
                    </div>
                </div>
                </li>)
            }
            </ul>
            <div className='d-flex align-items-center justify-content-center py-4'>
            {
                (page * DEFAULT_ROWS < total) &&<Button 
                variant='warning' 
                size="sm" 
                className='px-5' 
                onClick={()=>{ loadMore(); }}
                >
                MORE
                </Button>
            }
            </div>
        </div>
    </div>
}

function Search(props){
    let { search, setSearch, query, disabled } = props;
    return <ButtonGroup className='p-3 d-flex align-items-center'>
        <FormControl
            disabled={disabled}
            type="text"
            value={search}
            onChange={e=>{
                setSearch(e.currentTarget.value);
            }}
            placeholder='搜寻使用者'
            size='sm'
            style={{
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0
            }}
        />
        <Button size="sm" variant="success" className='text-nowrap' disabled={disabled} onClick={()=>{ query(); }}>搜寻</Button>
    </ButtonGroup>;
}
